import React from "react";
import "./App.scss";
import {BrowserRouter, Route, Switch} from "react-router-dom";
import Main from "./containers/Main";
import MilenaPage from "./containers/milena/MilenaPage";

function App() {
  return (
    <BrowserRouter>
      <Switch>
        <Route exact path="/milena" component={MilenaPage} />
        <Route path="/" component={Main} />
      </Switch>
    </BrowserRouter>
  );
}

export default App;
